import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { isLeadLabelProperty } from '../v2/utils/identifiers';
import { jsx as _jsx } from "react/jsx-runtime";
export const getPriorityStatusDotUse = ({
  property,
  objectTypeId,
  value
}) => {
  // Property options:
  // TASK - https://tools.hubteam.com/puma/objects/TASK/properties/hs_task_priority/details/
  // LEAD - https://tools.hubteam.com/puma/objects/LEAD/properties/hs_lead_label/details/
  // DEAL - https://tools.hubteam.com/puma/objects/DEAL/properties/hs_priority/details/
  // TICKET - https://tools.hubteam.com/puma/objects/TICKET/properties/hs_ticket_priority/details/

  const valueUpperCase = value ? value.toUpperCase() : '';
  switch (valueUpperCase) {
    case 'LOW':
    case 'COLD':
      return 'active';
    case 'MEDIUM':
    case 'WARM':
      return 'warning';
    case 'HIGH':
    case 'HOT':
      return 'danger';
    case 'NONE':
      {
        return undefined;
      }
    default:
      {
        if (property && isLeadLabelProperty(property, objectTypeId)) {
          return 'default';
        }
        return undefined;
      }
  }
};
export const PriorityStatusDot = ({
  property,
  objectTypeId,
  value
}) => {
  const use = getPriorityStatusDotUse({
    property,
    objectTypeId,
    value
  });
  if (!use) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    "data-status": use,
    children: /*#__PURE__*/_jsx(UIStatusDot, {
      role: "status",
      "data-test-id": `priority-status-dot-${value ? value.toLowerCase() : ''}`,
      use: use
    })
  });
};